import { NgModule } from '@angular/core';
import { CdkTableModule } from '@angular/cdk/table';

import { SukaTable } from './table.component';
import {
  SukaCell,
  SukaCellDef,
  SukaColumnDef,
  SukaFooterCell,
  SukaFooterCellDef,
  SukaHeaderCell,
  SukaHeaderCellDef
} from './cell';
import {
  SukaFooterRow,
  SukaFooterRowDef,
  SukaHeaderRow,
  SukaHeaderRowDef,
  SukaRow,
  SukaRowDef
} from './row';
import { CommonModule } from '@angular/common';
import { PaginationModule } from '../pagination/pagination.module';
import { SukaTableDataSource } from './table-data-source';
import { SukaTableSkeleton } from './table-skeleton.component';

const EXPORTED_DECLARATIONS = [
  // Table
  SukaTable,
  SukaTableSkeleton,

  // Template defs
  SukaHeaderCellDef,
  SukaHeaderRowDef,
  SukaColumnDef,
  SukaCellDef,
  SukaRowDef,
  SukaFooterCellDef,
  SukaFooterRowDef,

  // Cell directives
  SukaHeaderCell,
  SukaCell,
  SukaFooterCell,

  // Row directives
  SukaHeaderRow,
  SukaRow,
  SukaFooterRow,
];

@NgModule({
  imports: [
    CommonModule,
    CdkTableModule,
    PaginationModule,
  ],
  exports: [...EXPORTED_DECLARATIONS],
  declarations: [EXPORTED_DECLARATIONS],
})
class TableModule { }

export {
  // Module
  TableModule,

  // Table
  SukaTable,

  // Template defs
  SukaHeaderCellDef,
  SukaHeaderRowDef,
  SukaColumnDef,
  SukaCellDef,
  SukaRowDef,
  SukaFooterCellDef,
  SukaFooterRowDef,

  // Cell directives
  SukaHeaderCell,
  SukaCell,
  SukaFooterCell,

  // Row directives
  SukaHeaderRow,
  SukaRow,
  SukaFooterRow,

  // Datasource
  SukaTableDataSource,
};
